import React, { useState } from 'react';
import { Table, Input, Form, Space, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useChangeBackNum } from './../../../../utils/manager-admin/order';
import { message } from 'antd';
import { PrivilegedButton } from './../../../../component/privileged-button';

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ editable, children, dataIndex, record, retry, ...restProps }) => {
  const [editing, setEditing] = useState(false)
  const [backNum, setBackNum] = useState()
  const { changeBackNum } = useChangeBackNum() //退单

  const onChange = (e) => {
    if (e.target.value < 0) {
      message.error('请输入正确数量')
      return
    }
    setBackNum(e.target.value)
  }
  const handleSave = (goodsId, id) => {
    changeBackNum({
      goodsId,
      id,
      chargebackNum: backNum || record[dataIndex]
    }).then(res => {
      if (res.code === 200) {
        retry()
        setEditing(false)
        message.success(res.msg)
      } else {
        message.error(res.msg)
      }
    })
  }

  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <div className='flex'>
        <Input
          type='number'
          defaultValue={record[dataIndex]}
          style={{ width: '60%', marginRight: '15px' }}
          onChange={onChange}
        />
        <Space size={[10, 0]}>
          <Typography.Link onClick={() => {
            handleSave(record.goodsId, record.id)
            setEditing(false)
          }}>保存</Typography.Link>
          <Typography.Text
            type="secondary"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setEditing(false)
            }}
          >取消</Typography.Text>
        </Space>
      </div>
    ) : (
      <div className='flex'>
        <span className="mr-10">{record[dataIndex]}</span>
        <PrivilegedButton code={'club:appointment:chargeback'}>
          <div className='edit_icon'>
            <EditOutlined onClick={() => {
              setEditing(true)
            }} />
          </div>
        </PrivilegedButton>
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

export const EditableTable = ({ shopBuyList, isLoading, retry }) => {
  const columns = [
    {
      title: '商店ID',
      dataIndex: 'goodsId',
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
    },
    {
      title: '单价',
      dataIndex: 'goodsPrice',
    },
    {
      title: '数量',
      dataIndex: 'goodsNum',
    },
    {
      title: '下单时间',
      dataIndex: 'createTime',
    },
    {
      title: '退单',
      editable: true,
      dataIndex: 'chargebackNum',
      width: 250,
    },
    {
      title: '费用',
      dataIndex: 'consumptionAmount',
    }
  ]
  const editColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        retry
      }),
    }
  })
  return (
    <div>
      <Table
        components={
          {
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }
        }
        loading={isLoading}
        rowKey={record => record.id}
        dataSource={shopBuyList}
        columns={editColumns}
      />
    </div>
  );
}


